/* unplugin-vue-components disabled */import script from "./InvoiceStatusTag.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceStatusTag.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceStatusTag.vue?vue&type=style&index=0&id=4a659256&lang=scss"

const __exports__ = script;

export default __exports__